export const matchAllMetrics = Symbol('matchAllMetrics');
